var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { attrs: { id: "advertiser_submit" }, on: { submit: _vm.sendForm } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(
              "b-form-group",
              {
                attrs: { label: "Сейлз Менеджер", "label-for": "sales_manager" }
              },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      id: "sales_manager",
                      label: "name",
                      options: _vm.salesManagers,
                      reduce: function(manager) {
                        return manager.id
                      },
                      required: "",
                      multiple: ""
                    },
                    model: {
                      value: _vm.form.sales_managers,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "sales_managers", $$v)
                      },
                      expression: "form.sales_managers"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Аккаунт Менеджер",
                  "label-for": "account_manager"
                }
              },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      id: "account_manager",
                      label: "name",
                      options: _vm.accountManagers,
                      reduce: function(accountManager) {
                        return accountManager.id
                      },
                      required: ""
                    },
                    model: {
                      value: _vm.form.account_manager_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "account_manager_id", $$v)
                      },
                      expression: "form.account_manager_id"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            this.$currentUser.department === "adkey"
              ? _c(
                  "b-form-group",
                  { attrs: { label: "Канал продаж" } },
                  [
                    _c("v-select", {
                      attrs: {
                        options: _vm.channels,
                        reduce: function(channel) {
                          return channel.value
                        },
                        required: "",
                        searchable: false
                      },
                      model: {
                        value: _vm.form.channel,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "channel", $$v)
                        },
                        expression: "form.channel"
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.formErrors.channel, function(error) {
                      return _c("span", { staticClass: "alert-danger" }, [
                        _vm._v("Укажите канал продаж.")
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Дата изменения Аккаунт Менеджера",
                  "label-for": "title"
                }
              },
              [
                _c("datepicker", {
                  staticClass: "date",
                  attrs: {
                    "input-class": "form-control",
                    language: _vm.ru,
                    placeholder: ""
                  },
                  model: {
                    value: _vm.form.account_manager_change_date,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "account_manager_change_date", $$v)
                    },
                    expression: "form.account_manager_change_date"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "float-right",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v("Сохранить и выйти\n      ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66fd7c94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66fd7c94","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/MassUpdateAdvertisersModal.vue
// module id = 929
// module chunks = 0